import { api } from './api'

interface DashboardStats {
  total: number
  pending: number
  in_progress: number
  resolved: number
  by_priority: {
    low: number
    medium: number
    high: number
    urgent: number
  }
  by_department: Array<{
    department_id: string
    department_name: string
    count: number
  }>
}

interface Department {
  id: string
  name: string
  code: string
}

class DashboardService {
  async getStats(): Promise<DashboardStats> {
    try {
      const response = await api.get<{ success: boolean; data: DashboardStats }>('/dashboard/stats')
      return response.data.data
    } catch (error) {
      throw this.handleError(error)
    }
  }

  async getMyDepartments(): Promise<Department[]> {
    try {
      const response = await api.get<{ success: boolean; data: Department[] }>('/dashboard/my-departments')
      return response.data.data
    } catch (error) {
      throw this.handleError(error)
    }
  }

  private handleError(error: any): Error {
    if (error.response?.data?.error) {
      return new Error(error.response.data.error)
    }
    
    if (error.message) {
      return new Error(error.message)
    }
    
    return new Error('An unexpected error occurred')
  }
}

export const dashboardService = new DashboardService()


